import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UtilsService, UserService } from 'src/app/_services';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/_models';
import { AppPlusi, AppDateValidate } from 'src/app/_models/appplusi';
import { Router} from '@angular/router';

@Component({
  selector: 'app-user-app',
  templateUrl: './user-app.component.html',
  styleUrls: ['./user-app.component.css']
})
export class UserAppComponent implements OnInit {

  
  private user : User;
  public appPlus : AppPlusi;
  public appDateValidate : AppDateValidate;
  public appActivada : boolean;
  public activationCode: string;
  public idActivacio :string
  public dataValid: string;
  public showCodeBox: boolean;
  public loading : boolean;
  /*
  enum EstadoApp {
    SinTarjeta=-1,
    SinCodigo=0,
    CodSolicitado=1,
    CodValido=2,
    CodCaducado=3,
    OK = 4
  }
    No me deja hacerlo elegante
  */
   public estadoCodigo : number ; //0 sin codigo (nunca solicitado) 1 Solicitado 2 No caducado 3 Caducado 4 Codigo En uso
                                  //Los estados 0, 3 y 4 permiten generar un nuevo código. 

  constructor(
    private formBuilder: FormBuilder,
    private utils: UtilsService,
    private toastr: ToastrService,
    public translate : TranslateService,
    private users: UserService,
    private router: Router    
  ) 
  {  }

  @Output() cambioCodigo = new EventEmitter<string>();
  @Output() cambioDataValid = new EventEmitter<string>();
  @Output() cambioEstadoCodigo = new EventEmitter<number>();

  ngOnInit() {
    this.loading = false;
    this.showCodeBox=false;
    this.users.editingUser.subscribe( user => {
      this.user = user;
      this.loadData();
    });
}


  loadData(){
      if (this.user.id_plusi_card!=""){
        //Comprobar si el usuario tiene tarjeta, revisar si ya tiene algún código de activación
        this.users.checkAppActivationCode(this.user.dni). subscribe(
          appplus => {
          this.appPlus = appplus;
          this.appActivada=true;
          this.estadoCodigo=1;
          this.activationCode=appplus.id_activacio;
          this.cambioCodigo.emit(this.activationCode);
          this.cambioEstadoCodigo.emit(this.estadoCodigo);
        }, 
        error =>{
          this.appActivada = false;
          this.estadoCodigo = 0;
          this.cambioEstadoCodigo.emit(this.estadoCodigo);
        },
          ()=> { 

            if (this.appPlus.cert_entregat=="0"){
              this.users.checkAppActivationCodeDate(this.appPlus.id_activacio).subscribe(
                appdate => {

                  this.appDateValidate = appdate;
                  this.dataValid = appdate.data_until;

                  //this.appDateValidate.valid="0"; //Prueba para falsificar la caducidad del codigo

                  if (this.appDateValidate.valid=="1"){
                    this.estadoCodigo=2;
                    this.showCodeBox = true;
                    this.cambioEstadoCodigo.emit(this.estadoCodigo);
                  } 
                  else{ 
                    this.estadoCodigo=3;
                    this.showCodeBox = false;
                    this.cambioEstadoCodigo.emit(this.estadoCodigo);
                  } 
                  this.cambioDataValid.emit(this.dataValid);
                  
                  //Prueba para simular que no hay código
                  // this.estadoCodigo = 0; 
                  // this.appActivada=false;

                },
                error => {
                  this.appActivada = false;
                  this.estadoCodigo = 0;
                  this.cambioEstadoCodigo.emit(this.estadoCodigo);       
                }
              );
            }
            else{
              this.estadoCodigo=4;
              this.cambioEstadoCodigo.emit(this.estadoCodigo);
            }
          } 
        );
    } else {
      //No tiene tarjeta
      this.estadoCodigo=-1;
    }
  }
  
  requestNewActivationCode() {
    if (this.user.id_plusi_card!="") {
      //Si tiene tarjeta y desea un nuevo código de activación
      //Controlar que si el código actual es válido y en fecha, no permitir una nueva petición.

      if (this.estadoCodigo==2){
        this.showCodeBox=true;
      }
      else{
        this.loading = true;
        this.users.requestAppActivationCode(this.user.id_user, this.user.id_plusi_card, this.user.dni).subscribe(
          result => {
              this.activationCode = result;
              this.estadoCodigo=1;
              this.cambioCodigo.emit(this.activationCode);
          },
          error => {
            this.estadoCodigo=0;
          },
          () => {
            this.users.checkAppActivationCodeDate(this.activationCode).subscribe(
              appdate => {
                this.appDateValidate = appdate;
                this.dataValid = appdate.data_until;
                
                if (this.appDateValidate.valid=="1") this.estadoCodigo=2;
                else this.estadoCodigo=3;
                this.showCodeBox=true;
                this.cambioDataValid.emit(this.dataValid);
                this.loading = false;
              },
              error => {
                this.estadoCodigo=0;
                this.loading = false;
              }
            );
          }
        );
      }
    }
  }
  
  solicitarTarjeta(){
    this.router.navigate(['/user/card']);
  }
}
